// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YP-z","isFullWidth":"ZP-z","landingPageVideo":"_P-z","play":"aQ-z","iframeVideo":"bQ-z","playHidden":"cQ-z","fullwidth":"dQ-z"};